const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5244';

export const authStorage = {
  getToken: () => localStorage.getItem('admin_token'),
  setToken: (token) => localStorage.setItem('admin_token', token),
  clearToken: () => localStorage.removeItem('admin_token'),
  getUser: () => {
    const raw = localStorage.getItem('admin_user');
    return raw ? JSON.parse(raw) : null;
  },
  setUser: (user) => localStorage.setItem('admin_user', JSON.stringify(user)),
  clearUser: () => localStorage.removeItem('admin_user'),
  clearSession: () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
  },
};

let unauthorizedHandler = null;

export function setUnauthorizedHandler(handler) {
  unauthorizedHandler = handler;
}

async function request(path, { method = 'GET', body, auth = true } = {}) {
  const headers = {
    'Content-Type': 'application/json',
  };

  if (auth) {
    const token = authStorage.getToken();
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
  }

  const response = await fetch(`${API_BASE_URL}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  let payload = null;
  try {
    payload = await response.json();
  } catch {
    payload = null;
  }

  if (!response.ok) {
    if (response.status === 401 && auth) {
      unauthorizedHandler?.();
    }
    const message = payload?.message || `Request failed with status ${response.status}`;
    throw new Error(message);
  }

  return payload;
}

export const api = {
  login: (email, password) =>
    request('/api/auth/login', {
      method: 'POST',
      body: { email, password },
      auth: false,
    }),
  logout: () =>
    request('/api/auth/logout', {
      method: 'POST',
    }),
  me: () => request('/api/auth/me'),
  updateProfile: (data) =>
    request('/api/auth/profile', {
      method: 'PUT',
      body: data,
    }),
  dashboard: () => request('/api/dashboard'),
  list: (endpoint) => request(endpoint),
  create: (endpoint, data) =>
    request(endpoint, {
      method: 'POST',
      body: data,
    }),
  update: (endpoint, id, data) =>
    request(`${endpoint}/${id}`, {
      method: 'PUT',
      body: data,
    }),
  remove: (endpoint, id) =>
    request(`${endpoint}/${id}`, {
      method: 'DELETE',
    }),
  uploadImage: async (file) => {
    const token = authStorage.getToken();
    const formData = new FormData();
    formData.append('file', file);

    const response = await fetch(`${API_BASE_URL}/api/upload/image`, {
      method: 'POST',
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      body: formData,
    });

    let payload = null;
    try {
      payload = await response.json();
    } catch {
      payload = null;
    }

    if (!response.ok) {
      if (response.status === 401) {
        unauthorizedHandler?.();
      }
      const message = payload?.message || `Upload failed with status ${response.status}`;
      throw new Error(message);
    }

    return payload.data;
  },
};

export { API_BASE_URL };
